import React, { Component, useState, useEffect } from 'react'
import PropTypes from "prop-types";

import _ from "lodash";
import moment from 'moment';

// @material-ui/core components
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";
import Code from "@material-ui/icons/Code";
import Group from "@material-ui/icons/Group";
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Phone from "@material-ui/icons/Phone";

import Select from "react-select";

// core components
import Button from "components/CustomButtons/Button.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FileUpload from "components/CustomUpload/FileUpload";

import {
  Container,
  Row,
  Col,
  FormGroup,
  Input,
} from 'reactstrap';


// helpers
import { uploadFile } from "helpers/storage";
import { uuidv4 } from "helpers/math";
import { createOrg } from "helpers/https";

// database
import { createCoupon, updateCoupon } from 'db';

// styles
import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import CustomDropdown from 'components/CustomDropdown/CustomDropdown';
import { COUPON_STATUS_STRING, COUPON_STATUS } from 'constants/coupon';

const CouponForm = ({
  coupon,
  showAlertAction,
  requestClose
}) => {
  const [isReadyToSubmit, setIsReadyToSubmit] = useState(false);
  const [data, setData] = useState(coupon
    ? { ...coupon.data(), code: coupon.id }
    : {
      code: null,
      expires_at: null,
      max_count: null,
      status: COUPON_STATUS.NORMAL,
    });

  // data: {
  //   code: coupon_id,
  //   expires_at: moment(expires_at.toDate()).format('YYYY-MM-DD'),
  //   max_count,
  //   status,
  // },
  useEffect(() => {
    console.log('data = ', data);
    checkReadyToSubmit();
    return () => {
      // cleanup
    }
  }, [data])

  const onChange = (e, name, typeFn) => {
    const value = e.target.value;
    setData({ ...data, [name]: typeFn ? typeFn(value) : value });
  }

  const checkReadyToSubmit = () => {
    console.log("data = ", data);

    if (_.isEmpty(data.code)) {
      console.log('wrong code');
      return setIsReadyToSubmit(false);
    }

    if (_.isEmpty(data.expires_at)) {
      console.log('wrong expires_at');
      return setIsReadyToSubmit(false);
    }

    if (data.max_count === 0) {
      console.log('wrong max_count');
      return setIsReadyToSubmit(false);
    }

    if (!(data.status === 0 || data.status === 1)) {
      console.log('wrong status');
      return setIsReadyToSubmit(false);
    }

    return setIsReadyToSubmit(true);
  }

  const save = () => {
    const { expires_at } = data;
    // do save!
    return coupon && coupon.id
      ? updateCoupon(coupon.id, { ...data, expires_at: moment(expires_at).toDate() })
        .then(() => {
          showAlertAction({
            message: "쿠폰 정보가 갱신되었습니다.",
            color: 'danger',
          })
          requestClose();
        })
        .catch(e => {
          showAlertAction({
            message: "쿠폰 정보수정에 실패했습니다. 관리자에게 문의해주세요.",
            color: 'danger',
          })
        })
      : createCoupon({ ...data, expires_at: moment(expires_at).toDate() })
        .then(() => {
          showAlertAction({
            message: "쿠폰이 생성되었습니다.",
            color: 'danger',
          })
          requestClose();
        })
        .catch(e => {
          showAlertAction({
            message: "쿠폰 생성에 실패했습니다. 관리자에게 문의해주세요.",
            color: 'danger',
          })
        });
  }

  return (
    <Container>
      <Row>
        <Col xs={4}><label>쿠폰번호</label>&nbsp;(<small>필수</small>)</Col>
        <Col>
          <FormGroup>
            <Input
              value={data?.code || ''}
              placeholder='예) 2020XNA'
              onChange={event => onChange(event, "code")}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={4}><label>만료일</label>&nbsp;(<small>필수</small>)</Col>
        <Col>
          <FormGroup>
            <Input
              type='date'
              value={
                (data?.expires_at?.constructor.name === 'String'
                  ? data?.expires_at
                  : moment(data.expires_at?.toDate()).format('YYYY-MM-DD')) || ''}
              onChange={event => {
                console.log('event = ', event.target.value);
                onChange(event, "expires_at")
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={4}><label>발급상한</label>&nbsp;(<small>필수</small>)</Col>
        <Col>
          <FormGroup>
            <Input
              type='number'
              value={`${data?.max_count}` || ''}
              placeholder='예) 50'
              onChange={event => onChange(event, "max_count", (txt) => Number(txt))}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={4}><label>현재 쿠폰의 상태</label>&nbsp;(<small>필수</small>)</Col>
        <Col>
          <FormGroup>
            <Select
              className="react-select"
              classNamePrefix="react-select"
              name="status"
              value={{
                value: data?.status,
                label: COUPON_STATUS_STRING[data?.status]
              }}
              onChange={value => {
                if (value !== data?.status) {
                  setData({ ...data, status: value.value })
                }
              }}
              options={[
                {
                  value: "",
                  label: "쿠폰 상태",
                  isDisabled: true
                },
                ...COUPON_STATUS_STRING.map((item, idx) => ({ value: idx, label: item }))
              ]}
              placeholder="콘텐츠 버전 설정하기"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col className='text-left'>
          <Button round onClick={requestClose}>취소</Button>
        </Col>
        <Col className='text-right'>
          <Button round color="primary" onClick={save} disabled={!isReadyToSubmit}>
            저장
          </Button>
        </Col>
      </Row>
    </Container >
  )
}


CouponForm.propTypes = {
  coupon: PropTypes.object,
  requestClose: PropTypes.func.isRequired,
  showAlertAction: PropTypes.func.isRequired,
};

export default CouponForm;